document.addEventListener("DOMContentLoaded", function () {
  const ticker = document.querySelector(".ticker");

  if (!ticker) return;

  const list = ticker.querySelector(".ticker__items");
  const clone = list.cloneNode(true);
  ticker.appendChild(clone);
});
